import React from "react";
import Routes from "./Routes/Routes";
import "./app.css"


function App() {
  return (
    <>
     <Routes/> 
    </>
  );
}

export default App;
